export const INTERNAL_CONSTANTS = {
  AUTHENTICATION_STATUS: {
    IDLE: 'IDLE',
    PENDING: 'PENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
  },

  LAUNCH_STATUS: {
    RESOLVING: 'RESOLVING',
    INCOMPLETE: 'INCOMPLETE',
    READY: 'READY',
  },

  ENVIRONMENT: {
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    LOCAL: 'LOCAL',
  },

  NETWORK_CLIENT: {
    GRAPHQL: 'GRAPHQL',
  },

  SOCKET_STATUS: {
    DISCONNECTED: 'DISCONNECTED',
    CONNECTING: 'CONNECTING',
    CONNECTED: 'CONNECTED',
    RECONNECTING: 'RECONNECTING',
    ERROR: 'ERROR',
  },

  GAME_LAYOUTS: {
    STANDARD: 'STANDARD',
    UNIQUE: 'UNIQUE',
  },

  DEVICES: {
    MOBILE: 'MOBILE',
    TABLET: 'TABLET',
    DESKTOP: 'DESKTOP',
    MINI: 'MINI',
  },

  MODES: {
    NORMAL: 'NORMAL',
    MINI: 'MINI',
  },

  API: {
    MESSAGES: {
      TIMEOUT: 'Request timed out',
      NETWORK: 'Network error occurred',
      SUCCESS: 'Request successful',
      ERROR: 'Something went wrong',
    },
    LABELS: {
      REQUEST: 'Request',
      RESPONSE: 'Response',
      ERROR: 'Error',
    },
  },
}
